import React from 'react';

import ListSuccessStories from '../../../react4xp/components/ListSuccessStories';
import Section from '../../../react4xp/components/Section';

function SuccessStoryList({ title, cta, highlightedSuccessStory, successStories }) {
	return (
		<Section>
			<ListSuccessStories
				title={title}
				stories={successStories?.map(successStory => ({
					href: successStory.url && { url: successStory.url },
					img: successStory.imageSrc?.link && {
						src: successStory.imageSrc.link,
						srcSmall: successStory.imageSrcSmall?.link,
						alt: successStory.imageSrc?.alt
					},
					subtitle: successStory.taglineHeading,
					title: successStory.title
				}))}
				viewAll={cta && {
					text: cta.label,
					url: cta.url,
					isExternal: false
				}}
				featured={highlightedSuccessStory && {
					href: highlightedSuccessStory.url && { url: highlightedSuccessStory.url },
					img: highlightedSuccessStory.imageSrc?.link && {
						src: highlightedSuccessStory.imageSrc.link,
						srcSmall: highlightedSuccessStory.imageSrcSmall?.link,
						alt: highlightedSuccessStory.imageSrc.alt
					},
					subtitle: highlightedSuccessStory.taglineHeading,
					title: highlightedSuccessStory.title
				}}
			/>
		</Section>
	)
}

export default (props) => <SuccessStoryList {...props} />